<template>
    <div>
        <Loading :loadingHide="loadingHide"></Loading>
        <Header></Header>
        <div class="container worksContent">
            <div class="works-content">
                <div class="works-content-title">
                    <div class="works-content-title-left">
                        <span class="workName">{{ worksName }}</span>
                        <span class="workTime">{{`发布于：${createDate} ${updateDate? '更新于：' + updateDate : ''}`}}</span>
                        <div class="workControl">
                            <div><i class="el-icon-view"></i>&nbsp;{{ visNum }}</div>
                            <div class="giveLikeBox">
                                <svg-icon class="commend" @click="giveLike" :icon-class="zansStatus? 'zan-active' : 'zan' "/>
                                <!-- <i :class="zansStatus? 'commendLike' : 'commend'" @click="giveLike"></i> -->
                                <i>{{ likeNum }}</i>
                            </div>
                            <div class="collectBox">
                                <span :class="collectionStatus? 'collectLike' : 'collect'" @click="enshrine"></span>
                                收藏
                            </div>
                        </div>
                    </div>
                    <div class="works-content-title-right">
                        <img :src="authorAvatar" alt="" @click="goUserHome(authorId)">
                        <span @click="goUserHome(authorId)">{{ authorName }}</span>
                    </div>
                </div>
                <div class="works-content-content">
                    <div class="works-ralative">
                        <div v-if="scratchLoading" class="worksLoading">
                            <img :src="themeData.logo" alt="">
                            <div class="scratch-loading">
                                <div class="filled" :style="`width: ${width}%`"></div>
                            </div>
                        </div>
                        <div id="scratch-player"></div>
                    </div>
                    <div>
                        <div class="panel-container f-cb" v-show="keyboard != 1">
                            <div class="keyboardBox" v-if="keyboard == 2">
                                <div class="sxzu-bar-one">
                                    <div class="key left arrow-left" id="mleftBtn"></div> 
                                    <div class="key down arrow-down" id="mdownBtn"></div> 
                                    <div class="key right arrow-right" id="mrightBtn"></div> 
                                    <div class="key up arrow-up" id="mupBtn"></div>
                                </div> 
                                <div class="space f-fr" id="mspaceBtn"></div>
                                <div class="q" id="mqBtn">Q</div>
                                <div class="w" id="mwBtn">W</div>
                                <div class="e" id="meBtn">E</div>
                            </div>
                            <div class="keyboardBox" v-if="keyboard == 3">
                                <div class="sxzu-bar">
                                    <div class="key left arrow-left" id="mleftBtn"></div> 
                                    <div class="key down arrow-down" id="mdownBtn"></div> 
                                    <div class="key right arrow-right" id="mrightBtn"></div> 
                                    <div class="key up arrow-up" id="mupBtn"></div>
                                </div> 
                                <div class="sxzu-bar-wasd">
                                    <div class="key keyW arrow-w" id="mwBtn">W</div> 
                                    <div class="key keyA arrow-a" id="maBtn">A</div> 
                                    <div class="key keyS arrow-s" id="msBtn">S</div> 
                                    <div class="key keyD arrow-d" id="mdBtn">D</div>
                                </div> 
                            </div>
                            <div class="keyboardBox" v-if="keyboard == 4">
                                <div class="num-keypad">
                                    <div class="key number" id="m7Btn">7</div>
                                    <div class="key number" id="m8Btn">8</div>
                                    <div class="key number" id="m9Btn">9</div>
                                    <div class="key number" id="m4Btn">4</div>
                                    <div class="key number" id="m5Btn">5</div>
                                    <div class="key number" id="m6Btn">6</div>
                                    <div class="key number" id="m1Btn">1</div>
                                    <div class="key number" id="m2Btn">2</div>
                                    <div class="key number" id="m3Btn">3</div>
                                </div>
                            </div>
                            <div class="playGame" id="playGame">开始</div>
                            <div class="stopGame" id="stopGame">结束</div>
                        </div>
                        <div class="heatWorkShow">
                            <div class="heatWork">
                                <div>
                                    <svg-icon icon-class="zan"/>{{likeNum}}
                                    <!-- <span class="like"></span>{{likeNum}} -->
                                </div>
                                <div><i class="el-icon-view"></i>{{visNum}}</div>
                            </div>
                        </div>
                        <div class="works-content-info">
                            <div class="works_info_tab">
                                <span class="title">作品简介</span>
                                <!-- <span :class="works_info_tab == 'intro'? 'active' : ''" @click="works_info_tab = 'intro'">作品简介</span>
                                <span :class="works_info_tab == 'explain'? 'active' : ''" @click="works_info_tab = 'explain'">操作说明</span> -->
                            </div>
                            <span class="worksIntro" v-show="works_info_tab == 'intro'">{{ description }}</span>
                            <span class="explain" v-show="works_info_tab == 'explain'">{{ direction }}</span>
                        </div>
                        <div class="erweimaBox">
                            <span class="title">作品二维码</span>
                            <div class="weixinImgBox">
                                <div id="qrcode"></div>
                            </div>
                        </div>
                        <div class="works_fun">
                            <div @click="handleGeneratePoster">
                                <i class="el-icon-picture-outline"></i>
                                <span class="li-title">生成海报</span> 
                            </div>
                            <div @click="$router.push({name: 'sh', query: {id: worksId}})">
                                <i class="el-icon-tickets"></i>
                                <span>查看代码</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="video_pic" v-if="videoList && worksPic.length">
                <div class="video_pic_tab">
                    <span v-if="videoList" :class="video_pic_tab == 'video'? 'active' : ''" @click="video_pic_tab = 'video'">作品视频</span>
                    <span v-if="worksPic.length" :class="video_pic_tab == 'pic'? 'active' : ''" @click="video_pic_tab = 'pic'">作品图片</span>
                </div>
                <div class="works_video_pic">
                    <div class="works_video" v-show="videoList && video_pic_tab == 'video'">
                        <video style="max-height: 620px;" controls :src="videoList" v-if="videoList"></video>
                    </div>
                    <div class="works_pic" v-show="worksPic.length && video_pic_tab == 'pic'">
                        <img
                         class="works_pic_big"
                         v-for="(item, index) in worksPic"
                         :key="index"
                         :src="item"
                         v-show="index == Math.abs(worksPicIndex)% worksPic.length">
                        <div class="pic_control" v-if="worksPic.length">
                            <span class="pic_left" @click="worksPicIndex--"></span>
                            <div class="works_pic_list">
                                <img
                                 :class="index == Math.abs(worksPicIndex)% worksPic.length? 'works_pic_small active' : 'works_pic_small'"
                                 v-for="(item, index) in worksPic"
                                 :key="index"
                                 :src="item"
                                 @click="worksPicIndex = index">
                            </div>
                            <span class="pic_right" @click="worksPicIndex++"></span>
                        </div>
                    </div>
                    <span v-if="(video_pic_tab == 'video' && !videoList) || (video_pic_tab == 'pic' && !worksPic.length)" class="default">
                        <img src="@/assets/icon/notdata.png" alt="">
                        暂时没有相关数据
                    </span>
                </div>
            </div> -->
            <div class="comment">
                <div class="commentTitle" v-if="!loginStatus">
                    <span><i @click="contentLogin">登录</i>之后才能评论哦</span>
                </div>
                <div class="commentText" v-if="loginStatus">
                    <div class="po-re">
                        <textarea v-model="commentText" class="form-control" rows="4" maxlength="140" placeholder="记得保持言论友善和谦虚哦，互相学习，共同进步。"></textarea>
                        <p class="hky-write">还可以输入<span>{{ commentTextNum }}</span>个字</p>
                    </div>
                    <el-button type="primary" plain @click="postComment">留言</el-button>
                </div>
                <div class="commentList">
                    <ul class="commentList-list">
                        <li v-for="(comment, index) in commentList" :key="index">
                            <img :src="comment.reviewerAvatar"  @click="goUserHome(comment.reviewerId)" alt="">
                            <div class="commentUserInfo">
                                <span @click="goUserHome(comment.reviewerId)">{{ comment.reviewerName }}</span>
                                <span>{{ comment.createDate }}</span>
                                <span>{{ comment.content }}</span>
                                <div class="reply" >
                                    <i v-if="userInfo != null" class="el-icon-chat-line-square" @click="setReply(comment.id)">回复</i>
                                    <i v-if="(userInfo != null) && (userInfo.id == comment.reviewerId)" class="el-icon-delete" @click="deleteComment(comment.id, 'comment', index)">删除</i>
                                    <div v-if="replyId == comment.id">
                                        <div class="po-re">
                                            <textarea v-model="comment[index]" class="form-control" rows="4" maxlength="140"></textarea>
                                        </div>
                                        <el-button type="primary" plain class="worksContent-reply" @click="postReply(comment[index], comment)">回复</el-button>
                                    </div>
                                </div>
                                <div class="discussionsList">
                                    <ul class="discussionsList-list">
                                        <li v-for="(discussion, indexs) in comment.discussions" :key="indexs">
                                            <img @click="goUserHome(discussion.replierId)" :src="discussion.replierAvatar" alt="">
                                            <div class="commentUserInfo">
                                                <span @click="goUserHome(discussion.replierId)">{{ discussion.replierName }}</span>
                                                <span>{{ discussion.createDate }}</span>
                                                <span>{{ discussion.content }}</span>
                                                <div class="reply">
                                                    <i v-if="userInfo != null" class="el-icon-chat-line-square" @click="setReply(discussion.id, discussion.replierName , index, indexs, discussion[indexs])">回复</i>
                                                    <i v-if="(userInfo != null) && (userInfo.id == discussion.replierId)" class="el-icon-delete" @click="deleteComment(discussion.id, 'discussion', indexs, index)">删除</i>
                                                    <div v-if="replyId == discussion.id">
                                                        <div class="po-re">
                                                            <textarea v-model="discussion[indexs]" class="form-control" rows="4" maxlength="140"></textarea>
                                                        </div>
                                                        <el-button type="primary"  class="worksContent-reply" plain @click="postReply(discussion[indexs], comment)">回复</el-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <Foot></Foot>
        <el-dialog
         title="宣传海报"
         width="385px"
         :visible.sync="posterDialogVisible"
         @close="closePosterDialog">
        <el-alert
            title="电脑端右键另存为;手机端复制保存本地"
            type="info"
            center
            show-icon
            :closable="false">
        </el-alert>
        <div  class="posterBox">
            <canvas id="poster" width="345" height="612"></canvas>
            <img v-if="posterImgData" :src="posterImgData" alt="">
        </div>
    </el-dialog>
    </div>
</template>
<script>
import Loading from '@/components/loading';
import communityApi from "@/request/api/community";
import institutionApi from '@/request/api/institution';
import userApi from "@/request/api/user";
import fileApi from "@/request/api/file";
import Header from '@/components/header';
import Foot from '@/components/foot';
import QRCode from 'qrcodejs2';

export default {
    components: {
        Loading,
        Header,
        Foot
    },
    computed: {
        dialogVisible: {
            get() {
                return this.$store.state.dialogVisible;
            },
            set() {
                this.$store.commit('setDialogVisible', false)
            }
        },
        userInfo() {
            return this.$store.state.userInfo;
        },
        themeData() {
            return this.$store.state.themeData;
        }
    },
    data() {
        return {
            worksId: "", //当前works的id
            cover: "", //作品首图
            createDate: "", //创建时间
            updateDate: "", //更新时间
            description: "", //简介
            direction: "", //操作说明
            likeNum: 0, //赞
            worksName: "", //作品名称
            // studentInfo: {}, //用户对象
            authorAvatar: "", //作者头像
            authorId: "", //作者ID
            authorName: "", //作者名
            visNum: "", //访问数
            worksTypes: {}, //标签列表
            worksUrl: "", //作品url
            commentList: [], //评论列表
            zansStatus: false, //点赞状态
            collectionStatus: false, //收藏状态
            loginStatus: false, //登录状态
            commentText: [], //评论
            commentTextNum: 140, //评论字数
            replyId: "", //点击的当前回复框对应id
            textareaShow: false, //回复框显隐
            isMobile: false, //是否是移动设备
            scratchLoading: true, //scratch未加载完显示
            qrcodeShow: false, //二维码显示状态
            worksDetailsState: false, //作品详情接口返回
            worksDiscussionState: false, //评论列表接口返回
            loadingHide: false,
            width: 0,
            interval: null,
            keyboard: 2,
            dataURL: "",
            posterDialogVisible: false,
            posterBg: require('@/assets/poster.png'),
            posterImgData: "",
            ctx: null,
            works_info_tab: 'intro',
            video_pic_tab: 'video',
            worksPic: [],
            worksPicIndex: 0,
            sb3Url: ""
        }
    },
    watch: {
        worksDetailsState() {
            if(this.worksDetailsState && this.worksDiscussionState) {
                this.loadingHide = true;
            }
        },
        worksDiscussionState() {
            if(this.worksDetailsState && this.worksDiscussionState) {
                this.loadingHide = true;
            }
        },
        commentText() {
            this.commentTextNum = 140 - this.commentText.length;
        },
        userInfo() {
            if(userApi.getToken()) {
                this.loginStatus = true;
            } else {
                this.loginStatus = false;
            }
        },
    },
    created() {
        $(document).scrollTop(0); //进入页面到顶部
        this.getPageInfo();
        this.ifMobile();
        if(userApi.getToken()) {
            this.loginStatus = true;
        } else {
            this.loginStatus = false;
        }
    },
    mounted() {
        this.setLookNum();
        this.getScratchJS();
        this.makeCode();
    },
    beforeRouteLeave (to, from, next) {
        document.getElementById('stopGame').click();
        next();
    },
    methods: {
        //获取当前页信息
        getPageInfo() {
            if(this.$route.params.id) {
                this.worksId = this.$route.params.id;
            } else {
                let arr = location.href.split('?');
                this.worksId = arr[0].slice(location.href.lastIndexOf('/') + 1)
            }
            communityApi.worksDetailsById(this.worksId, res => {
                if(res.succeed) {
                    let { data } = res;
                    this.cover = data.cover? data.cover : this.cover;
                    this.createDate = data.createDate? data.createDate : this.createDate;
                    this.updateDate = data.updateDate? data.updateDate : this.updateDate;
                    this.description = data.description? data.description : this.description;
                    this.direction = data.direction? data.direction : this.direction;
                    this.likeNum = data.likeNum;
                    this.worksName = data.name? data.name : this.name;
                    this.authorAvatar = data.authorAvatar? data.authorAvatar : this.authorAvatar;
                    this.authorId = data.authorId? data.authorId : this.authorId;
                    this.authorName = data.authorName? data.authorName : this.authorName;
                    this.worksUrl = data.url? data.url : this.worksUrl;
                    this.visNum = data.visNum;
                    this.worksTypes = data.worksTypes? data.worksTypes : this.worksTypes;
                    this.zansStatus = data.zansStatus? true : false;
                    this.collectionStatus = data.collectionStatus? true : false;
                    this.keyboard = data.keyboard? data.keyboard : 2;
                    this.videoList = data.workVideoUrl? data.workVideoUrl : "",
                    this.worksPic = data.workPictureList? data.workPictureList : [],
                    this.sb3Url = data.url? data.url : "";
                    this.getComment(); //获取回页面信息成功再获取当前作品评论作品
                }
                this.worksDetailsState = true;
            })
        },
        //查看次数
        setLookNum() {
            let params = {
                institutionId: this.themeData.id, 
                type: 'workViewNumByPC'
            };
            institutionApi.statisticsByInstitutionId(params, res => {
            });
        },
        //判断移动端
        ifMobile() {
            if(/Android|webOS| iPhone | iPad | iPod |BlackBerry|opera mini|opera mobile|appleWebkit.*mobile|mobile/i.test(navigator.userAgent)) {
                this.isMobile = true;
                sessionStorage.setItem('mobile', this.isMobile);
            } else {
                sessionStorage.removeItem('mobile');
            }
        },
        //加载scratch
        getScratchJS() {
            this.width += 15;
            const oScript1 = document.createElement('script');
            oScript1.type = 'text/javascript';
            oScript1.src = 'https://static-highcoding.oss-cn-zhangjiakou.aliyuncs.com/player/compatibility.js';
            document.body.appendChild(oScript1);
            this.width += 25;
            const oScript2 = document.createElement('script');
            this.width += 5;
            oScript2.type = 'text/javascript';
            oScript2.src = 'https://scratch-highcoding.oss-accelerate.aliyuncs.com/lib/community/lib.min.js';
            this.width += 5;
            oScript2.onload = () => {
                clearInterval(this.interval);
                this.width = 88;
                setTimeout(() => {
                    this.width = 95;
                }, 1500)
                setTimeout(() => {
                    this.width = 99;
                    this.scratchLoading = false;
                }, 3000)
            }
            document.body.appendChild(oScript2);

        },
        //点击标签跳转到对应发现作品的分类页
        goTypePage(id,name) {
            this.$router.push({name: "works", params: {typeId: id, typeName: name } })
        },
        //生成二维码
        makeCode () {
            let url = `https://${location.hostname}/scratchworks/${this.worksId}`;
            let qrcode = new QRCode('qrcode', {
                width: 100,
                height: 100,
                text: url
            })
        },
        //获取作品评论列表
        getComment() {
            communityApi.worksDiscussionList(this.worksId, res => {
                if(res.succeed) {
                    this.commentList = res.data? res.data: [];
                }
                this.worksDiscussionState = true;
            })
        },
        //登录弹框显隐
        contentLogin() {
            this.$store.commit('setDialogVisible', true)
        },
        //点赞
        giveLike() {
            if(this.$store.state.loginBtnShow) {
                this.contentLogin();
            } else {
                if(this.zansStatus) {
                    communityApi.cancelLikeWorks(this.worksId, res => {
                        if(res.succeed) {
                            this.zansStatus = false;
                            this.likeNum -= 1;
                        }
                    })
                } else {
                    communityApi.likeWords(this.worksId, res => {
                        if(res.succeed) {
                            this.zansStatus = true;
                            this.likeNum += 1;
                        }
                    })
                }
            }
        },
        //收藏
        enshrine() {
            if(this.$store.state.loginBtnShow) {
                this.contentLogin();
            } else {
                if(this.collectionStatus) {
                    communityApi.cancelCollectWorks(this.worksId, res => {
                        if(res.succeed) {
                            this.collectionStatus = false;
                        }
                    })
                } else {
                    communityApi.collectWorks(this.worksId, res => {
                        if(res.succeed) {
                            this.collectionStatus = true;
                        }
                    })
                }
            }
        },
        getBase64Image(img, width, height) {
            //width、height调用时传入具体像素值，控制大小 ,不传则默认图像大小
            var canvas = document.createElement("canvas");
            canvas.width = width ? width : img.width;
            canvas.height = height ? height : img.height;
    
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            var dataURL = canvas.toDataURL();
            return dataURL;
        },
        //生成海报
        handleGeneratePoster() {
            this.posterDialogVisible = true;
            this.$nextTick(() => {
                var canvas = document.getElementById("poster");
                this.ctx = canvas.getContext("2d");
                this.ctx.fillStyle = sessionStorage.getItem('themeColor');
                // this.ctx.fillRect(0, 0, 380, 670)
                this.ctx.fillRect(0, 0, 345, 612)
                // this.ctx.fillRect(0, 0, 290, 510)
                var img1 = new Image();
                img1.onload = () => {
                    // this.ctx.drawImage(img1, 0, 0, 380, 670);
                    this.ctx.drawImage(img1, 0, 0, 345, 612);
                    // this.ctx.drawImage(img1, 0, 0, 290, 510);
                    fileApi.urlToBase64(`https:${sessionStorage.getItem('logo')}`, res => {
                        var img2 = new Image();
                        img2.src = res.data;
                        img2.onload = () => {
                            this.ctx.drawImage(img2, 10, 30, 80, img2.height/(img2.width/80));
                            var img3 = new Image();
                            img3.src = document.getElementById('qrcode').children[1].getAttribute('src');
                            img3.onload = () => {
                                // this.ctx.drawImage(img3, 153, 488, 71, 71);
                                this.ctx.drawImage(img3, 140, 446, 63, 63);
                                // this.ctx.drawImage(img3, 117, 371, 54, 54);
                                fileApi.urlToBase64(`https:${this.cover}`, res => {
                                    var img4 = new Image();
                                    img4.src = res.data;
                                    img4.onload = () => {
                                        // this.ctx.drawImage(img4, 33, 192, 312, 232);
                                        this.ctx.drawImage(img4, 30, 176, 283, 211);
                                        // this.ctx.drawImage(img4, 25, 146, 238, 178);
                                        this.posterImgData = canvas.toDataURL("image/png", 1.0);
                                    }
                                })
                            }
                        }
                    })
                    this.ctx.fillStyle = '#333';
                    // this.ctx.font = "15px Arial";
                    this.ctx.font = "13px Arial";
                    // this.ctx.font = "11px Arial";
                    this.ctx.textAlign = 'center';
                    // this.ctx.fillText(`${this.authorName}同学的作品`, 190, 145);
                    this.ctx.fillText(`${this.authorName}同学的作品`, 172.5, 133);
                    // this.ctx.fillText(`${this.authorName}同学的作品`, 145, 112);
                    let worksName = this.worksName;
                    if(worksName.length > 7) {
                        worksName = worksName.slice(0, 7);
                    }
                    // this.ctx.fillText(`《${worksName}》`, 190, 163)
                    this.ctx.fillText(`《${worksName}》`, 172.5, 150)
                    // this.ctx.fillText(`《${worksName}》`, 145, 127)
                }
                img1.src = this.posterBg;
                
            })
        },
        //关闭海报弹框
        closePosterDialog() {
            this.ctx.clearRect(0, 0, 380, 670);
        },
        //提交评论
        postComment() {
            if(this.commentText) {
                let params = {
                    "content": this.commentText,
                    "worksId": this.worksId
                }
                communityApi.saveDiscussion(params, res => {
                    if(res.succeed) {
                        this.getComment();
                        // this.commentList.unshift()
                        this.commentText = "";
                    }
                })
            } else {
                this.$message({
                    message: '评论内容不能为空，请您输入内容',
                    type: 'warning',
                });
            }
        },
        //回复显隐
        setReply(id, text, index, indexs, content) {
            this.replyId = id;
            if(index != undefined  && indexs != undefined) {
                this.$set(this.commentList[index].discussions[indexs], indexs, "回复@" + text + "：");
            }
            
        },
        //回复
        postReply(text, item) {
            if(text) {
                let params = {
                    "reviewer": {
                        "id": item.reviewerId
                    },
                    "works": {
                        "id": this.worksId
                    },
                    "discussionId": item.id,
                    "content": text
                };
                communityApi.saveComment(params, res => {
                    if(res.succeed) {
                        this.getComment();
                        this.replyId = "";
                    }
                })
            } else {
                this.$message({
                    message: '内容不能为空，请您输入内容',
                    type: 'warning',
                });
            }
        },
        //删除评论
        deleteComment(id, type, index, indexs) {
            communityApi.deleteDiscussion(id, res => {
                if(res.succeed) {
                    // this.getComment();
                    if(type == 'comment') {
                        this.commentList.splice(index, 1);
                    } else if(type == 'discussion') {
                        this.commentList[indexs].discussions.splice(index, 1);
                    }
                }
            })
        },
        //查看卡片用户
        goUserHome(id) {
            this.$router.push({ name: "personhome", query: { id }});
        },
    },
}
</script>
<style lang="scss">
.dialog-content {
    position: relative;
    min-height: 300px;
}
.posterBox {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.posterBox img {
    position: absolute;
    top: 0;
    left: 0;
}
.worksContent {
    padding: 50px 0;
    padding-left: 0 !important;
    padding-right: 0 !important;
    background-color: #F3F5F7;
    ul, li {
        padding: 0;
        margin: 0;
    }
    .works-content {
        width: 100%;
    }
    .works-content-title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 128px;
        padding: 20px;
        background-color: #fff;
    }
    .works-content-title .works-content-title-left .workName {
        display: block;
        color: #333;
        font-size: 20px;
        font-weight: bold;
    }
    .works-content-title .works-content-title-left .workTime {
        display: block;
        padding: 5px 0;
        color: #999;
    }
    .works-content-title .works-content-title-left .workControl {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .works-content-title .works-content-title-left .workControl div {
        padding: 0 30px;
        border-right: 2px solid #ececec;
    }
    .works-content-title .works-content-title-left .workControl div:nth-child(1) {
        padding-left: 0px;
    }
    .works-content-title .works-content-title-left .workControl div:last-child {
        border-right: none;
    }
    .works-content-title .works-content-title-right {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        width: 368px;
        padding: 0 50px;
        border-left: 2px solid #ececec; 
        cursor: pointer;
    }
    .works-content-title .works-content-title-right img {
        width: 85px;
        height: 85px;
        border-radius: 50%;
        margin-right: 20px;
    }
    .works-content-title .works-content-title-right span {
        margin-left: 0;
        color: #000;
        font-size: 14px;
        font-weight: 600;
    }
    .collect {
        display: inline-block;
        width: 15px;
        height: 15px;
        margin-right: 5px;
        background-image: url("../assets/zan1.png");
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
        color: #FFE200;
        cursor: pointer;
    }
    .commend {
        cursor: pointer;
    }
    .works-content-content {
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: flex-start;
        margin: 15px 0;
        line-height: 15px;
        user-select: none;
    }
    .works-ralative {
        position: relative;
        width: 775px;
        height: 630px;
        padding: 20px 25px 25px;
        background-color: #fff;
    }
    .worksLoading {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background-color: var(--theme-color);
        z-index: 999;
    }
    .worksLoading img {
        max-width: 300px;
        max-height: 35%;
    }
    .scratch-loading{
        width: 80%;
        height: 50px;
        margin-top: 5rem;
        background-color: #e6e6e6;
        border: 5px solid #fff;
        border-radius: 25px;
        box-shadow: 0 12px 5px rgba(0, 0, 0, 0.2);
        box-sizing: border-box;
        overflow: hidden;
    }
    .scratch-loading .filled{
        height: 100%;
        width: 0%;
        border-radius: 25px;
        background-color: var(--theme-color);
    }
    .works-content-info {
        width: 380px;
        height: 240px;
        background-color: #fff;
        padding: 20px;
    }
    .works-content-info .worksIntro,
    .works-content-info .explain {
        display: block;
        color: #333;
        font-size: 15px;
        font-weight: 600;
        padding: 10px 0;
    }
    .works-content-info .works_info_tab,
    .video_pic .video_pic_tab {
        display: flex;
        flex-direction: row;
        position: relative;
        width: 100%;
        height: 35px;
        user-select: none;
    }
    // .works-content-info .works_info_tab span,
    // .video_pic .video_pic_tab span {
    //     display: inline-block;
    //     width: 50%;
    //     font-size: 18px;
    //     font-weight: 600;
    //     line-height: 33px;
    //     text-align: center;
    //     color: var(--theme-color);
    //     background-color: #fff;
    //     cursor: pointer;
    // }
    // .works-content-info .works_info_tab span.active,
    // .video_pic .video_pic_tab span.active  {
    //     color: #fff;
    //     background-color: var(--theme-color);
    // }
    .erweimaBox {
        width: 380px;
        height: 180px;
        background-color: #fff;
        padding: 20px;
        margin: 15px 0;
    }
    .works-content-info .works_info_tab .title,
    .erweimaBox .title {
        display: block;
        width: 100%;
        padding: 3px 0 10px;
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        border-bottom: 2px solid #ececec;
    }
    .weixinImgBox {
        position: relative;
        padding: 10px;
        width: 100%;
        height: 135px;
    }
    #qrcode {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .works_fun {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 380px;
        height: 180px;
        background-color: #fff;
    }
    .works_fun div {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 110px;
        height: 80px;
        color: #fff;
        font-size: 16px;
        margin: 0 20px;
        background-color: #053B5E;
        border-radius: 5px;
        cursor: pointer;
    }
    .works_fun div i {
        font-size: 27px;
    }
    .works_fun div:nth-child(1) {
        background-color: #67C23A;
    }
    .video_pic {
        width: 100%;
        padding: 15px;
        background-color: #fff;
    }
    .video_pic .video_pic_tab span{
        width: 150px;
    }
    .video_pic .works_video_pic {
        width: 100%;
        height: 635px;
    }
    .video_pic .works_video {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 15px;
    }
    .video_pic .works_pic {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 15px;
    }
    .video_pic .works_pic_big {
        max-width: 100%;
        height: 510px;
    }
    .video_pic .pic_control {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding-top: 15px;
    }
    .video_pic .pic_control .pic_left,
    .video_pic .pic_control .pic_right {
        display: block;
        width: 50px;
        height: 90px;
        background-image: url(~@/assets/left.png);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
    }
    .video_pic .pic_control .pic_right {
        background-image: url(~@/assets/right.png);
    }
    .video_pic .pic_control .works_pic_list {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: calc(100% - 100px);
        user-select: none;
        overflow-x: scroll;
    }
    .video_pic .pic_control .works_pic_list::-webkit-scrollbar {
        width: 3px;
        height: 10px;
    }
    .video_pic .pic_control .works_pic_list::-webkit-scrollbar-thumb {
        width: 3px;
        height: 5px;
        background: #999aaa;
        border-radius: 3px;
    }
    .video_pic .pic_control .works_pic_small {
        width: 150px;
        height: 90px;
        border: 3px solid #fff;
        border-radius: 5px;
    }
    .video_pic .pic_control .works_pic_small.active {
        border: 3px solid var(--theme-color);
    }
    .comment {
        background-color: #fff;
        padding: 20px;
        margin: 15px 0;
    }
    .commentTitle {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100px;
        background-color: #F3F5F7;
    }
    .commentTitle span {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        color: var(--theme-color);
        font-size: 15px;
        font-weight: 600;
    }
    .commentTitle span i {
        display: block;
        width: 80px;
        height: 45px;
        padding: 12px;
        color: var(--theme-fontColor);
        font-style: initial;
        text-align: center;
        line-height: 21px;
        background-color: var(--theme-color);
        border-radius: 5px;
        cursor: pointer;
    }
    textarea.form-control {
        width: 100%;
        height: auto;
        box-shadow: none;
        resize: none;
        background: #fdfdfd;
        padding: 10px;
        padding-bottom: 40px;
        margin-bottom: 5px;
        font-weight: normal;
        border-radius: 5px;
        outline: none;
    }
    .form-control:focus {
        border-color: #FFE200;
        box-shadow: none;
    }
    .hky-write {
        position: absolute;
        bottom: 8px;
        left: 10px;
        padding: 3px 10px;
        background: #eee;
        border-radius: 50px;
        font-size: 12px;
        color: #4db87c;
    }
    .commentText {
        padding: 10px 0 30px;
        border-bottom: 2px solid #ececec;
    }
    .commentText button {
        padding: 10px 30px;
    }
    .default  {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 120px;
        color: #8a8a8a;
        font-size: 15px;
    }
    .default  img {
        width: 80px;
    }






     .el-dialog__body {
        padding: 0 5px 5px 5px;
    }
    .el-button--primary.is-plain {
        color: var(--theme-color);
        border-color: var(--theme-color);
        background: #fff;
    }
    .el-button--primary.is-plain:focus, .el-button--primary.is-plain:hover {
        background-color: var(--theme-color);
        color: #fff;
    }
    .worksContent-reply span {
        color: var(--theme-color) !important;
        margin-bottom: 0 !important;
    }
    .worksContent-reply:hover span {
        color: #fff !important;
        margin-bottom: 0 !important;
    }
    .panel-container {
        position: relative;
        display: none;
        width: 375px;
        min-height: 200px;
        margin-bottom: 15px;
        background-color: #323238;
    }
    .keyboardBox {
        width: 100%;
    }
    .sxzu-bar {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        width: 160px;
        height: 150px;
    }
    .sxzu-bar-one .key,
    .sxzu-bar-wasd .key,
    .sxzu-bar .key {
        position: absolute;
        width: 60px;
        height: 60px;
    }
    .sxzu-bar-one,
    .sxzu-bar-wasd {
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
        width: 160px;
        height: 150px;
    }
    .num-keypad {
        position: absolute;
        top: 50px;
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        width: 100%;
    }
    .num-keypad .number{
        width: 25%;
        height: 35px;
        margin: 5px;
        color: #B4BCBD;
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        line-height: 35px;
        background: #585A60;
        border-radius: 5px;
    }
    .num-keypad .number:active {
        background: #73777B;
        color: #fff;
    }
    .arrow-left {
        background: url(../assets/icon/left.png) no-repeat center/contain;
    }
    .arrow-right {
        background: url(../assets/icon/right.png) no-repeat center/contain;
    }
    .arrow-up {
        background: url(../assets/icon/up.png) no-repeat center/contain;
    }
    .arrow-down {
        background: url(../assets/icon/down.png) no-repeat center/contain;
    }
    .keyA,
    .left {
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }
    .left:active {
        background: url(../assets/icon/left_active.png) no-repeat center/contain;
    }
    .keyD,
    .right {
        right: 0;
        top: 50%;
        transform: translateY(-50%);
    }
    .right:active {
        background: url(../assets/icon/right_active.png) no-repeat center/contain;
    }
    .keyW,
    .up {
        top: 0;
        left: 50%;
        transform: translateX(-50%);
    }
    .up:active {
        background: url(../assets/icon/up_active.png) no-repeat center/contain;
    }
    .keyS,
    .down {
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
    }
    .down:active {
        background: url(../assets/icon/down_active.png) no-repeat center/contain;
    }
    .sxzu-bar-wasd .key,
    .space, .q, .w, .e{
        position: absolute;
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 60px;
        height: 60px;
        align-items: center;
        background: #585A60;
        color: #B4BCBD;
        font-size: 33px;
        border-radius: 50%;
    }
    .sxzu-bar-wasd .key:active,
    .q:active, .w:active, .e:active {
        background: #73777B;
        color: #fff;
    }
    .space {
        width: 90px;
        height: 90px;
        right: 10px;
        bottom: 25px;
        background: url(../assets/icon/space.png) no-repeat center/contain;
    }
    .space.default {
        width: 110px;
        height: 110px;
        right: 20px;
        bottom: 50%;
        transform: translateY(50%);
    }
    .space:active {
        background: url(../assets/icon/space_active.png) no-repeat center/contain;
    }
    .q {
        right: 105px;
        bottom: 20px;
    }
    .w {
        right: 90px;
        bottom: 90px;
    }
    .e {
        right: 28px;
        top: 18px;
    }
    .playGame,
    .stopGame {
        position: absolute;
        left: 50%;
        top: 15px;
        transform: translateX(-50%);
        width: 45px;
        height: 25px;
        line-height: 25px;
        font-size: 15px;
        text-align: center;
        color: #fff;
        background: green;
        border-radius: 5px;
    }
    .stopGame {
        display: none;
        background: red;
    }
    
    .works-content-title .content {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        font-size: 13px;
    }
    .works-content-title .content span {
        margin-left: 15px;
        color: #666;
    }
    
    .works-content-title .works-remind {
        display: block;
        color: #999;
        font-size: 14px;
        margin: 10px 0;
    }
    
    .heatWorkShow {
        display: none;
        width: 100%;
    }
    .heatWork {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        padding: 10px 30px 0;
    }
    .heatWork i {
        margin-right: 5px;
    }
    .heatWork div {
        margin-right: 10px;
    }
    .heatWork .like {
        padding: 7px;
        margin-right: 5px;
        background-image: url("../assets/zan5.png");
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
        cursor: pointer;
    }
    
    
    .tag .works-content-info-type {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        padding: 15px 0;
    }
    .tag .works-content-info-type li{
        display: inline-block;
        width: 45px;
        padding: 2px 5px;
        margin-right: 15px;
        color: var(--theme-color);
        font-size: 14px;
        letter-spacing: 1px;
        outline: 0;
        border-radius: 255px 18px 225px 18px/18px 225px 18px 255px;
        border: solid 2px var(--theme-color);
        list-style: none;
        cursor: pointer;
    }
    .generatePoster {
        padding: 20px 0;
    }
    .generatePosterBox {
        padding: 10px 0 50px 37px
    }
    .lookScratch {
        padding: 20px 0;
        box-sizing: border-box;
    }
    .lookScratch span {
        position: relative;
        padding: 15px 30px;
        color: #fff;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 1px;
        outline: none;
        border: none;
        background-color: var(--theme-color);
        border-radius: 10px;
        box-shadow: 0 6px var(--theme-color);
        cursor: pointer;
        box-sizing: border-box;
    }
    .lookScratch span:hover {
        box-shadow: 0 4px var(--theme-color);
        top: 2px;
    }
    .giveLikeBox {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .giveLikeBox i {
        font-style: inherit;
    }
    .works-fun {
        border-top: 1px solid #eee;
        padding: 10px 20px;
        margin: 40px -20px 0;
    }
    .works-fun ul {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
    }
    .works-fun ul li {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        font-size: 14px;
        color: #666;
        margin-right: 15px;
        // border-left: 1px solid var(--theme-color);
    }
    
    
    .collectBox {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .voteBox {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .voteBox .vateBtn {
        margin-left: 15px;
    }
    .collectLike,
    .commendLike {
        display: inline-block;
        width: 15px;
        height: 15px;
        margin-right: 5px;
        background-image: url("../assets/zan2.png");
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
        color: #FFE200;
        cursor: pointer;
    } 
    .collect {
        background-image: url("../assets/start1.png");
    }
    .collectLike {
        background-image: url("../assets/start2.png");
    }
    
    .commentList {
        padding: 20px;
        margin-bottom: 50px;
    }
    .commentList-list li {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        padding-top: 26px;
        padding-bottom: 15px;
        border-bottom: 2px solid #ececec;
    }
    .commentUserInfo {
        width: 100%;
    }
    .commentList-list li img {
        width: 50px;
        height: 50px;
        border-radius: 4px;
        cursor: pointer;
    }
    .commentList-list li div {
        margin-left: 20px;
        font-size: 15px;
    }
    .commentList-list li div span:nth-child(1) {
        display: inline-block;
        color: #1eace5;
        cursor: pointer;
    }
    .commentList-list li div span:nth-child(1):hover {
        color: #000;
    }
    .commentList-list li div span:nth-child(2) {
        display: block;
        font-size: 12px;
        color: #777;
    }
    .commentList-list li div span:nth-child(3) {
        display: block;
        line-height: 25px;
        word-break: break-word;
    }
    .commentList-list li div .reply {
        color: #666;
        font-size: 13px;
        letter-spacing: 1px;
        margin: 0;
    }
    .commentList-list li div .reply i:hover {
        color: #000;
        cursor: pointer;
    }
    .commentList-list li div .reply div {
        margin: 5px 0;
    }
    .commentList-list li div .reply .po-re .hky-write span {
        margin-bottom: 0;
    }
    .discussionsList {
        background: #eee;
        margin-left: 0px !important;
        padding: 0 15px;
    }
    .po-re {
        position: relative;
    }
    
    .navList{
        display: none;
    }
}
@media (max-width: 880px) {
    .worksContent {
        padding: 1px 0;
        .works-ralative {
            position: relative;
            width: auto;
            height: auto;
            min-height: 280px;
        }
        .worksLoading {
            position: fixed;
        }
        .detailsPage {
            padding: 5px;
        }
        .container {
            width: 100%;
        }
        .panel-container {
            display: block;
            width: 100%;
        }  
        .comment, 
        .works-content-title,
        .works-fun,
        .lookScratch  {
            display: none;
        }
        .works-content-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            overflow: hidden;
        }
        .stage-wrapper_stage-canvas-wrapper_n2Q5r {
            width: 100% !important;
            height: 100% !important;
        }
        .works-content-info {
            width: 100%;
            margin-left: 0px;
        }
        .works-content-info ul {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            padding: 20px 10px;
        }
        .works-content-info ul li {
            padding: 0 10px;
        }
        .tag .works-content-info-type {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: flex-start;
            align-items: center;
            padding: 15px 10px;
        }
        .heatWorkShow {
            display: block;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/worksContent.vue